/**
 * Shared demolition projectile constants.
 *
 * Kept in services so damageModel can read them without an upward edge into
 * structures. Numeric values must stay bit-identical to the historical
 * demolitionPhysicsConstants exports.
 */

export const CANNONBALL_RADIUS = 0.3;
export const CANNONBALL_DENSITY = 42;
export const CANNONBALL_SPEED = 55;

/** Additional demolition projectiles. Densities are tuned for this unit system. */
export const SPIKE_RADIUS = 0.12;
export const SPIKE_DENSITY = 110;
export const SPIKE_SPEED = 62;
export const RUBBLE_RADIUS = 0.28;
export const RUBBLE_DENSITY = 32;
export const RUBBLE_SPEED = 32;
export const CHARGE_RADIUS = 0.16;
export const CHARGE_DENSITY = 70;
export const CHARGE_SPEED = 30;
export const CONCUSSION_RADIUS = 0.18;
export const CONCUSSION_DENSITY = 90;
export const CONCUSSION_SPEED = 42;
